try {
	var data = require('../../datas/docs/index.json')
} catch (e) {
	var fs = require('fs')
	fs.writeFileSync('datas/docs/index.json', '{}', 'utf-8')
	data = require('../../datas/docs/index.json')
}

module.exports = function(assets) {
  return data ? data[assets] : undefined
}



// WEBPACK FOOTER //
// ./src/modules/assets.js